import React from "react";
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

import LocationFooter from "../LocationFooter/LocationFooter";
import {carBrands} from "../../../AppConstants";
export default function (props) {
    return(<footer className={'footerContainer'} style={{backgroundColor:props.backgroundColor}} >
        <div style={{paddingTop:'50px'}} className={'container'}>
            <div className={'row'}>
              {props.brand ?<React.Fragment>
                <div className={'col-lg-6 col-sm-12'}>
                  {props.brand.map(location=>{
                    return <LocationFooter {...props} key={Math.random()} location={{locationName:location.name,locationURL:location.url}} tele={location.number} email={location.email}/>
                  })}
                </div>
                  {props.socialMedia &&
                  <div style={{textAlign:'center'}} className={'col-lg-6 col-sm-12'}>
                      <a  target={'_blank'} href={props.socialMedia.facebook_url} rel="noreferrer"> <FacebookIcon  fontSize="large" /></a>
                      <a target={'_blank'} href={props.socialMedia.linkedin_url} rel="noreferrer"><LinkedInIcon  fontSize="large"/></a>
                      <a target={'_blank'} href={props.socialMedia.instagram_url} rel="noreferrer"><InstagramIcon  fontSize="large"/></a>
                  </div>}

                <div className={'col-lg-6 col-sm-12'} >
                  <a style={{fontFamily:`${props.brand.name === carBrands.jaguar.title ? 'Jaguar-Secondary':'LandRover-Secondary'}`}} target={'_blank'} href={props.socialMedia.link === carBrands.jaguar.link ? 'https://www.jaguarmetropoolnoord.be/nl/privacy-policy/' :'https://www.landrovermetropoolnoord.be/nl/privacy-policy/'} rel="noreferrer">Cookie Policy</a>
                  <a style={{marginLeft:'20px'}} target={'_blank'} href={props.socialMedia.link === carBrands.jaguar.link ? 'https://www.jaguarmetropoolnoord.be/nl/privacy-policy/' :'https://www.landrovermetropoolnoord.be/nl/privacy-policy/'} rel="noreferrer">Privacy Policy</a>
                </div>

              </React.Fragment>:''}
            </div>
        </div>
    </footer>)
}
